var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A5475",
    d: "M18 2 16.59.59l-6.34 6.34 1.41 1.41L18 2ZM22.24.59 11.66 11.17 7.48 7 6.07 8.41 11.66 14l12-12L22.24.59ZM.41 8.41 6 14l1.41-1.41L1.83 7 .41 8.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check-double.c34f5dcdaf6dc62ac69dd605f243f7df.svg";
export { ForwardRef as ReactComponent };